import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, INTEGRATORS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'integrator',
  url: `${INTEGRATORS_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
